export default __webpack_public_path__ + "static/media/a024-7.0b23843d.svg";